import { Tab, Tabs } from '@material-ui/core';
import React, { useReducer, useState } from 'react';

import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';

const DigitalCheckout = ({ showLoader = () => {} }) => {
  const [tabValue, setTabValue] = useState(0);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    integrationSource: {
      value: '',
      fieldName: 'Integration Source',
      errors: {},
      validations: [],
    },
    integrationSourceSelected: {
      value: '',
      fieldName: '',
      errors: {},
      validations: [],
    },
    hostingType: {
      value: false,
      fieldName: 'On-Prem Hosting',
      errors: {},
      validations: [],
    },
    apiIntegrationHotelId: {
      value: '',
      fieldName: 'Hotel ID',
      errors: {},
      validations: ['required'],
    },
    apiIntegrationUrl: {
      value: '',
      fieldName: 'URL',
      errors: {},
      validations: [],
    },
  });

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  return (
    <>
      <form className='digital-checkin'>
        <div className='col-12 hotel-service-tab-section'>
          <div className='col col-xl-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Integration Settings' />
              <Tab label='Configurable features' />
            </Tabs>
          </div>
        </div>

        {tabValue === 0 && (
          <div className='mx-4'>
            <IntegrationSource
              formData={formData}
              setFormData={setFormData}
              section='Digital Check-Out'
              headTitle='Integration Source'
              showLoader={showLoader}
            />
          </div>
        )}
      </form>
    </>
  );
};

export default DigitalCheckout;
